import React from "react";
import "./Legal.css";

const MentionsLegales = () => {
  return (
    <section className="legal-page">
      <div className="legal-content">
        <h1>Mentions Légales</h1>
        <hr />

        <p>
          Ce site Web est la propriété de la société <strong>JCP Industries,</strong> société
          par actions simplifiée, immatriculée au RCS de Bobigny sous le numéro 385 401 518,
          dont le siège est situé à Neuilly-Plaisance (France).
        </p>

        <p>
          Tous les textes, images, graphiques, vidéos contenus dans ce site ainsi que leur
          assemblage, sont la propriété exclusive de JCP Industries ou de leurs auteurs.
        </p>

        <p>
          L'utilisation, la reproduction, la diffusion de ces informations ou de tout ou en
          partie des éléments, par quelque procédé que ce soit, et sur quelque support que ce
          soit composant ce site sans autorisation préalable écrite de <strong>JCP Industries</strong> ou
          de leurs auteurs sont strictement interdites et pourra faire l'objet de toute action
          appropriée, notamment d'une action en contrefaçon.
        </p>

        <p>
          L'hébergement du site est assuré par MTI SEVEN, société par actions simplifiée,
          SIREN 922 200 118, N° TVA : FR25922200118, Siège social situé au
          52 rue de l'Église – 78500 Sartrouville – France
        </p>

        <p>
          Le site web est réalisé par JCP Industries.
        </p>

        <p>
          Le responsable de publication du site est le Directeur Général de JCP Industries.
        </p>

        <h2>Propriété du nom de domaine</h2>

        <p>
          Le nom de domaine{" "}
          <a href="https://www.jcpindustries.fr" target="_blank" rel="noreferrer">
            www.jcpindustries.fr
          </a>{" "}
          est la propriété exclusive de la société <strong>JCP Industries</strong>.
        </p>

        <h2>Conditions d'utilisation</h2>

        <p>
          L'utilisation du site implique l'acceptation pleine et entière des présentes mentions
          légales.
        </p>
        <p>
          Le site{" "}
          <a href="https://www.jcpindustries.fr" target="_blank" rel="noreferrer">
            www.jcpindustries.fr
          </a>{" "}
          est accessible 7 jours sur 7, 24 heures sur 24, sauf cas de force majeure, difficulté
          technique ou opération de maintenance.
        </p>
        <p>
          L'utilisateur s'engage à utiliser le site dans le respect de la législation en vigueur
          et à ne pas porter atteinte aux droits de JCP Industries ou de tiers.
        </p>

        <p>Il est strictement interdit d'utiliser ce site pour :</p>
        <ul>
          <li>diffuser des contenus illicites, injurieux, diffamatoires, discriminatoires ou violents ;</li>
          <li>tenter d'accéder de manière non autorisée au système d'information du site ;</li>
          <li>utiliser le site dans un but de nuisance, perturbation, saturation ou détournement de son contenu.</li>
        </ul>

        <h2>Politique de Confidentialité des données &amp; Cookies</h2>

        <p>
          Les informations concernant les données personnelles et les cookies sont disponibles
          dans notre Politique de confidentialité :{" "}
          <a href="/donnees-personnelles">
            https://www.jcpindustries.fr/donnees-personnelles
          </a>
        </p>

        <h2>Limitation de responsabilité</h2>

        <p>
          <strong>JCP Industries</strong> s'efforce d'assurer l'exactitude et la mise à jour
          des informations diffusées sur le site. Toutefois, <strong>JCP Industries</strong> ne
          peut garantir l'exactitude, l'exhaustivité ou la mise à jour continue de l'ensemble
          des contenus.
        </p>
        <p>
          Les informations fournies sur le site le sont à titre indicatif et ne sauraient
          dispenser l'utilisateur d'une vérification complémentaire.
        </p>

        <p><strong>JCP Industries</strong> ne pourra être tenue pour responsable :</p>
        <ul>
          <li>de tout dommage direct ou indirect résultant de l'utilisation du site ou de l'impossibilité d'y accéder ;</li>
          <li>de la présence éventuelle de virus ou de tout autre logiciel malveillant susceptible d'affecter l'équipement informatique de l'utilisateur ;</li>
          <li>de l'usage qui pourrait être fait du contenu publié par l'utilisateur lorsqu'un espace interactif est disponible.</li>
        </ul>

        <p>
          L'utilisateur demeure seul responsable de ses équipements informatiques, de sa connexion
          au réseau Internet et de toute action effectuée à partir de son espace ou de ses accès.
        </p>

        <p>
          Pour toute question, ou pour signaler un contenu illicite, vous pouvez nous contacter.
        </p>

        <div className="legal-contact">
          <p><strong>JCP Industries</strong></p>
          <p>5 Allée Roland Garros - ZI Les Renouillères,</p>
          <p>93360 Neuilly-Plaisance,</p>
          <p>
            <a href="mailto:jcp-contact@orange.fr">jcp-contact@orange.fr</a>
            {" "}/ 01 49 44 08 59
          </p>
        </div>

      </div>
    </section>
  );
};

export default MentionsLegales;
